import React, { useState } from 'react';
import i18next from 'i18next';
import { useDispatch, useSelector } from 'react-redux';
import cn from 'classnames';

import AuthActions from '~redux/Auth/actions';
import CustomModal from '~components/CustomModal';
import FormWrapper from '~components/FormWrapper';
import { MODALS } from '~redux/Modal/constants';

import { INITIAL_VALUES } from './constants';
import Head from './components/Head';
import styles from './styles.module.scss';
import FinishRegisterForm from './components/FinishRegisterForm';
import EmailAndCodeForm from './components/EmailAndCodeForm';
import { validationSchema } from './schema';

function LoginModal() {
  const dispatch = useDispatch();
  const [apiErrors, setApiErrors] = useState([]);
  const open = useSelector((state) => state.modal[`${MODALS.LOGIN}ModalIsOpen`]);

  const { signInWithEmailCode, sendSignInCodeToEmail, currentUser } = useSelector((state) => state.auth);

  const handleSendCode = (values) => {
    dispatch(AuthActions.sendSignInCodeToEmail(values.email));
  };

  const handleFinishRegister = (values) =>
    signInWithEmailCode
      ? dispatch(AuthActions.registerFromEmailCode(values, (error) => setApiErrors(error)))
      : dispatch(AuthActions.signInWithCode(values.email, values.verificationCode));
  return (
    <CustomModal
      hideCloseButton={sendSignInCodeToEmail}
      className={cn(styles.modal, {
        [styles.longModal]: !!signInWithEmailCode
      })}
      modal={MODALS.LOGIN}
      shouldCloseOnOverlayClick={false}
      isOpen={open}>
      <Head title={i18next.t('Login:title')} />
      <FormWrapper
        initialValues={INITIAL_VALUES}
        validationSchema={validationSchema(signInWithEmailCode)}
        onSubmit={sendSignInCodeToEmail ? handleFinishRegister : handleSendCode}>
        {({ values, setFieldValue, handleSubmit, errors, avoidErrorUntilSubmit, submitCount }) => (
          <form
            className={cn(styles.form, {
              [styles.longForm]: !!signInWithEmailCode
            })}
            onSubmit={handleSubmit}>
            {signInWithEmailCode && currentUser ? (
              <FinishRegisterForm
                avoidErrorUntilSubmit={avoidErrorUntilSubmit}
                submitCount={submitCount}
                values={values}
                setFieldValue={setFieldValue}
                errors={errors}
                apiErrors={apiErrors}
              />
            ) : (
              <EmailAndCodeForm values={values} setFieldValue={setFieldValue} />
            )}
          </form>
        )}
      </FormWrapper>
    </CustomModal>
  );
}

export default LoginModal;
